export type BrowserLocalTimestamp = {
  timezone: string;
  localDateTime: string;
};

/**
 * Formats a date as a timezone-local ISO-like value without converting it to UTC.
 * Example: 2026-08-01T21:33:45 for a user in America/Nassau.
 */
export function formatLocalDateTimeInTimezone(date: Date, timezone: string): string {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });

  const parts = formatter.formatToParts(date);
  const getPart = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value || "00";

  return `${getPart("year")}-${getPart("month")}-${getPart("day")}T${getPart("hour")}:${getPart("minute")}:${getPart("second")}`;
}

/** Captures the current browser timezone plus an exact browser-local timestamp. */
export function getBrowserLocalTimestamp(now = new Date()): BrowserLocalTimestamp {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  return {
    timezone,
    localDateTime: formatLocalDateTimeInTimezone(now, timezone),
  };
}
